<template>
	<div style="padding: 10px;">
		<el-row :gutter="20">
			<el-col :span="3">
				<el-select style="width: 100%;" filterable v-model="selecttype" placeholder="请选择类型" @change="changeType">
					<el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"  > </el-option>
				</el-select>
			</el-col>
			<el-col :span="4">
				<el-select style="width: 100%;" filterable clearable v-model="selectorgid" placeholder="请选择校区">
					<el-option v-for="item in orgList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
				</el-select>
			</el-col>
			<el-col :span="12"> 
				<div style="min-width: 300px;">
					<el-button type="primary" @click="queryPointSetting" icon="el-icon-search">搜索</el-button>
					<el-date-picker style="width: 50%;margin-left: 10px;margin-right: 10px;" v-model="timerange" type="daterange" format="yyyy-MM-dd"
						range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="timeRangeChange">
					</el-date-picker>
					<el-button @click="downLoadExcle" icon="el-icon-download">导出</el-button>
				</div>
			</el-col>
		</el-row>
		<div style="margin-top: 10px;max-height: 760px;overflow: auto;">
			<div v-if="selecttype == 'offline'">
				<div style="float: left;width: 120px;height: 100px;border-radius: 20px;margin-right: 10px;margin-top: 10px;"
					:style="{border: air.value == '-1' ? ' solid 1px #fa3534' : 'solid 1px #e1e1ee'}" v-for="(air,index) in offlineList" :key="index">
					<div style="font-size: 14px;text-align: center;" :style="{color: air.value == '0' ? 'red' : ''}">{{air.orgname}}</div>
					<div style="font-size: 12px;margin-top: 10px;text-align: center;" :style="{color: air.value == '-1' ? 'red' : ''}">{{air.locname}}</div>
					<div style="font-size: 12px;margin-top: 10px;text-align: center;" :style="{color: air.value == '-1' ? 'red' : ''}">{{air.name}}</div>
					<div style="font-size: 14px;margin-top: 10px;text-align: center;" :style="{color: air.value == '-1' ? 'red' : ''}">
						{{air.value == '-1' ? '离线' : '在线'}}
					</div>
				</div>
				<div style="clear: both;"></div>
			</div>
			<div v-else>
				<div style="float: left;width: 120px;height: 100px;border-radius: 20px;margin-right: 10px;margin-top: 10px;"
					:style="{border: air.value == '1' ? ' solid 1px #fa3534' : 'solid 1px #e1e1ee'}" v-for="(air,index) in offlineList" :key="index">
					<div style="font-size: 14px;text-align: center;" :style="{color: air.value == '1' ? 'red' : ''}">{{air.orgname}}</div>
					<div style="font-size: 12px;margin-top: 10px;text-align: center;" :style="{color: air.value == '1' ? 'red' : ''}">{{air.locname}}</div>
					<div style="font-size: 12px;margin-top: 10px;text-align: center;" :style="{color: air.value == '1' ? 'red' : ''}">{{air.name}}</div>
					<div style="font-size: 14px;margin-top: 10px;text-align: center;" :style="{color: air.value == '1' ? 'red' : ''}">
						{{air.value == '1' ? '有故障' : '无故障'}}
					</div>
				</div>
				<div style="clear: both;"></div>
			</div>
		</div>
	</div>
</template>

<script>
	//import dayjs from 'dayjs'
	import axios from 'axios'
	import { queryOffLineAirs, queryAllOrg } from '/static/apiUrl.js'
	import { baseUrl, prefix } from '/public/baseUrl.js'
	export default {
		name : 'OffLine',
		data() {
			return {
				orgList : [],
				typeList : [
					{
						name: '离线',
						id : 'offline'
					},
					{
						name: '故障',
						id : 'fualt'
					}
				],
				offlineList : [],
				selectorgid : '',
				selecttype : 'offline',
				timerange : '',
				searchInfo : {
					begin : '',
					end : ''
				}
			}
		},
		mounted() {
			this.initData()
			this.queryPointSetting()
		},
		components: {
		},
		methods: {
			initData() {
				this.orgList = []
				queryAllOrg().then(res => {
					if(0 == res.code){
						res.datas.forEach((org) => {
							if("XQ" == org.type){
								this.orgList.push(org)
							}
						})
					}
				})
			},
			timeRangeChange(e){
				this.searchInfo.begin = this.$formatDate(e[0],'yyyy-MM-dd')
				this.searchInfo.end = this.$formatDate(e[1],'yyyy-MM-dd')
				//console.log(this.searchInfo)
			},
			changeType(){
				this.queryPointSetting()
			},
			queryPointSetting(){
				this.offlineList = []
				queryOffLineAirs({
					oid : this.selectorgid,
					type: this.selecttype
				}).then(res => {
					if(0 == res.code){
						res.datas.forEach((item) => {
							let splitstr = item.name.split("#")
							this.offlineList.push({
								name : splitstr[0]+'#空调',
								value : item.icon,
								orgname : item.orgname,
								locname : item.locname
							})
						})
					}
				})
			},
			downLoadExcle(){
				if(this.searchInfo.begin == '' || this.searchInfo.end == ''){
					this.$message({
						showClose: true,
						message: "请选择导出时间",
						type: 'error'
					});
					return
				}
				const loading = this.$loading({
					lock: true,
					text: '下载数据中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				let filename = ""
				this.orgList.forEach((org) => {
					if(org.id == this.selectorgid){
						filename = org.name +'空调'+(this.selecttype == 'offline' ? '离线' : '故障')+'统计.xlsx'
					}
				})
				let autherheader = sessionStorage.getItem("authToken")
				let citycode = localStorage.getItem("citycode")
				axios.get(baseUrl+prefix+citycode+'/api/report/orgOFExport?oid='+this.selectorgid+'&type='+this.selecttype+'&begin='+this.searchInfo.begin+'&end='+this.searchInfo.end, 
				{
					headers: {
						'Content-Type': 'blob',
						Authorization: autherheader
					},
					timeout : 500000,
					responseType : 'blob'
				}).then(response => {
					loading.close();
					const url = window.URL.createObjectURL(new Blob([response.data]),{type:`'application/vnd.ms-excel';chartset=utf-8`});
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', filename);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link)
					
				}).catch(err => {
					console.log(err)
					loading.close();
					this.$message({
						showClose: true,
						message: "超时",
						type: 'error'
					});
				});
			},
			
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>